<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive :include="cachesRoutes">
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("app");
export default {
  name: "App",
  beforeDestroy() {
    localStorage.removeItem("exam-type");
  },
  computed: {
    ...mapState(["transitionName", "cachesRoutes"])
  }
};
</script>

<style>
:root {
  --theme-text-color--: "";
  --theme-color--: "";
  --theme-btn-bg-color--: "";
  --theme-btn-text-color--: "";
  --theme-bg-color--: "";
  --theme-tag-bg-color--: "";
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* height: auto; */
  height: 100%;
  background: #f7f9fc;
}
#app > div {
  width: 100%;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.van-list .van-cell {
  line-height: revert;
  padding: 0;
}
.van-list .van-cell::after {
  border-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue